import React from 'react';
import { BUILD_VS_BUY } from '../../../content/enterpriseMessaging';
import SectionSurface from '../shared/SectionSurface';

export default function BuilderPositioning() {
  return (
    <SectionSurface
      variant="default"
      decor="none"
      bleed="both"
      flowTop
      flowBottom
      overlap
    >
      <div className="container-x py-3 sm:py-4">
        <p className="text-center text-sm text-ink-800 leading-6 max-w-4xl mx-auto">
          <span className="font-semibold text-ink-900">{BUILD_VS_BUY.headline}</span>
          {' '}
          {BUILD_VS_BUY.body}
        </p>
      </div>
    </SectionSurface>
  );
}
